import { render, staticRenderFns } from "./EnglishPage.vue?vue&type=template&id=7f30983b&scoped=true&"
import script from "./EnglishPage.vue?vue&type=script&lang=js&"
export * from "./EnglishPage.vue?vue&type=script&lang=js&"
import style0 from "./EnglishPage.vue?vue&type=style&index=0&id=7f30983b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f30983b",
  null
  
)

export default component.exports